/**
 * @generated SignedSource<<5aa86137c0e47c665ece5e4900b8240c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurrentPackagesModal_club$data = {
  readonly name: string;
  readonly " $fragmentType": "CurrentPackagesModal_club";
};
export type CurrentPackagesModal_club$key = {
  readonly " $data"?: CurrentPackagesModal_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurrentPackagesModal_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrentPackagesModal_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "29cb37eac1b47c482589d9f7ab4b2c04";

export default node;
